import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import ProcessRecovery from "./ProcessRecovery";

const RoutesProcess = () => {
    return (
        <>
            <Route
                path="process/monitor/:processId"
                element={
                    <PrivateRoute>
                        <ProcessRecovery />
                    </PrivateRoute>
                }
            />
        </>
    );
};
export default RoutesProcess;
